// Lin's Bistro — fixed ordering rules (do not change via admin)
export const RESTAURANT_SETTINGS = {
  deliveryAlwaysEnabled: true,
  maxDeliveryMiles: 6,
  deliveryCloseBufferMinutes: 15,
  deliveryPayment: { cash: false, online: true },
  pickupPayment: { cash: true, online: true },
};
